import { Text, Tooltip } from '@mantine/core';
import { getTaskCreatedAtDisplay } from './helpers';

type TaskCreatedAtPropsType = {
  createdAt: string;
};

export const TaskCreatedAt: React.FC<TaskCreatedAtPropsType> = ({
  createdAt,
}) => {
  const createdAtDisplay = getTaskCreatedAtDisplay(createdAt);

  return (
    <Tooltip
      label={createdAtDisplay.absolute}
      position="bottom"
      transitionProps={{ duration: 200 }}
      bg="layout.10"
      p="xs"
      offset={8}
    >
      <Text
        c="text.6"
        size="xs"
        lh={1.35}
        w="fit-content"
        aria-label={createdAtDisplay.absolute}
      >
        {createdAtDisplay.relative}
      </Text>
    </Tooltip>
  );
};
